<script lang="ts">
  import { inTelegram } from '../lib/telegram';
  import Icon from './Icon.svelte';

  let {
    busy,
    error,
    onFile,
    onSample,
  }: { busy: boolean; error: string | null; onFile: (f: File) => void; onSample: () => void } = $props();

  // В Telegram файл не перетаскивают, а выбирают на телефоне.
  const tg = inTelegram();

  let input: HTMLInputElement;

  function pick(): void {
    if (!busy) input.click();
  }
</script>

<div
  class="zone"
  class:busy
  role="button"
  tabindex="0"
  aria-label="Выбрать документ .docx для проверки"
  onclick={pick}
  onkeydown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      pick();
    }
  }}
>
  <input
    bind:this={input}
    class="visually-hidden"
    type="file"
    tabindex="-1"
    accept=".docx,.docm,.md,.markdown,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/markdown"
    onchange={(e) => {
      const file = e.currentTarget.files?.[0];
      e.currentTarget.value = '';
      if (file) onFile(file);
    }}
  />
  {#if busy}
    <div class="spinner" aria-hidden="true"></div>
    <p class="title">Проверяем документ…</p>
    <p class="hint">Обычно это меньше секунды</p>
  {:else}
    <div class="icon"><Icon name="upload" size={26} /></div>
    {#if tg}
      <p class="title">Выберите файл .docx</p>
      <p class="hint">курсовую, ВКР или отчёт</p>
    {:else}
      <p class="title">Перетащите файл .docx сюда</p>
      <p class="hint">или нажмите, чтобы выбрать его на компьютере</p>
    {/if}
    <span class="btn btn-primary">Выбрать файл</span>
  {/if}
</div>

{#if error}
  <div class="error" role="alert">{error}</div>
{/if}

<div class="below">
  <button class="link" onclick={onSample} disabled={busy}>Попробовать на примере курсовой</button>
  <span class="sep" aria-hidden="true">·</span>
  <span class="local"><Icon name="lock" size={15} /> {tg ? 'Файл проверяется на вашем устройстве' : 'Файл не покидает ваш компьютер'}</span>
</div>

<style>
  .zone {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 44px 24px 36px;
    border: 1.5px dashed var(--border-strong);
    border-radius: 20px;
    background:
      radial-gradient(120% 100% at 50% 0%, color-mix(in srgb, var(--accent-soft) 70%, transparent), transparent 70%),
      var(--surface);
    box-shadow: var(--shadow);
    cursor: pointer;
    text-align: center;
    transition:
      border-color 0.15s,
      transform 0.15s;
  }

  .zone:hover {
    border-color: var(--accent);
  }

  .zone.busy {
    cursor: progress;
  }

  .icon {
    width: 56px;
    height: 56px;
    margin-bottom: 8px;
    display: grid;
    place-items: center;
    border-radius: 16px;
    background: var(--accent-soft);
    color: var(--accent);
  }

  .title {
    font-size: 18px;
    font-weight: 620;
    letter-spacing: -0.01em;
  }

  .hint {
    color: var(--text-2);
    font-size: 14px;
  }

  .zone .btn {
    margin-top: 14px;
    pointer-events: none;
  }

  .spinner {
    width: 44px;
    height: 44px;
    margin: 6px 0 12px;
    border-radius: 50%;
    border: 3px solid var(--accent-soft);
    border-top-color: var(--accent);
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .error {
    margin-top: 12px;
    padding: 12px 14px;
    border-radius: 12px;
    background: var(--error-soft);
    color: var(--error);
    font-size: 14px;
    text-align: left;
  }

  .below {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px 10px;
    margin-top: 14px;
    font-size: 14px;
    color: var(--text-2);
  }

  .sep {
    color: var(--text-3);
  }

  .local {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .local :global(svg) {
    color: var(--ok);
  }
</style>
